import { Box, chakra, keyframes, Spinner, Stack, Text, useColorModeValue, VStack } from '@chakra-ui/react';
import Header from '../../../../components/Header/Header';
import CardHeaderMobile from '../../../../components/Mobile/header';
import { useRequestMyRegistration } from '../../../../services/hooks/CandidateArea/useRequestMyRegistration';
import { IoMdHome } from 'react-icons/io';
import ListRegistrationMobilePage from './ListSelectiveProcess';

const floatIn = keyframes`
      from { opacity: 0; transform: translateY(18px) scale(0.995); }  
  `;

const AnimatedBox = chakra(Box, {
  baseStyle: {
    animation: `${floatIn} 420ms cubic-bezier(.2,.9,.3,1) both`,
  },
});

interface IOwnProps {}

const CandidateAreaMobilePage: React.FC<IOwnProps> = () => {
  const borderColor = useColorModeValue('gray.100', 'gray.700');

  const { isError, isLoading, data } = useRequestMyRegistration();

  return (
    <Stack height="100%" w="100%" top={0} bg="white" gap={0}>
      <Header />
      <VStack mt={0} flex={1} overflowY="auto" py={2}>
        {(isLoading && (
          <VStack flex={1} w="100%" justify="center">
            <Spinner emptyColor="gray.100" color="blue.500" size="xl" />
            <Text fontSize="sm">Buscando inscrições...</Text>
          </VStack>
        )) ||
          (isError && <Text>Erro ao trazer os dados.</Text>) || (
            <AnimatedBox
              borderRadius="lg"
              boxShadow="lg"
              mx={3}
              p={{ base: 5, md: 10 }}
              borderWidth={'1px'}
              borderColor={borderColor}
              bg="white"
              flex={1}
              display="flex"
            >
              <VStack boxSizing="border-box" maxW="lg" spacing={4} align="stretch">
                <CardHeaderMobile
                  title="Minhas inscrições"
                  subTitle="Bem-vindo à sua área de inscrições! Aqui você pode acompanhar tudo em um só lugar: ver os detalhes das suas inscrições, atualizar dados, emitir a segunda via do boleto, conferir o local de prova, enviar títulos, acompanhar os resultados e muito mais."
                  badgeText="Área do Candidato"
                  badgeIcon={<IoMdHome size={13} />}
                  gap={1}
                  px={2}
                  colorScheme="blue"
                />
                <VStack spacing={3} align="stretch" h="100%">
                  {data ? (
                    data?.map((selectiveProcess) => (
                      <ListRegistrationMobilePage
                        key={selectiveProcess.selective_process_id}
                        selectiveProcess={selectiveProcess}
                      />
                    ))
                  ) : (
                    <Text>Você ainda não possui inscrição em um processo seletivo</Text>
                  )}
                </VStack>
              </VStack>
            </AnimatedBox>
          )}
      </VStack>
    </Stack>
  );
};

export default CandidateAreaMobilePage;
